// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2_ATx","name":"Header_name__2MsBD","birthday":"Header_birthday__3a1P7","skeleton":"Header_skeleton__35blG"};